
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parrainage",
      function () {
        return require("private-next-pages/parrainage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parrainage"])
      });
    }
  